import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { complaintProjection } from "../sanity/complaint.projection"

/**
 * Single complaint that will be displayed on the page
 */
export const queryComplaint = {
  async complaint(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), id, cdn = false } = args
    const { user } = context
    const client = context.sanityClient
    client.config({
      ...AppSettings.sanityConfigByLang(lang),
      useCdn: cdn,
    })

    await checkPermissions({
      user,
      domainObject: DomainObjects.COMPLAINTS,
      operation: Operations.READ,
    })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const complaint = await client.fetch(
      groq`*[_type=="complaint" && _id==$id ${draftsFilter}][0] {
          ${complaintProjection()}
        }`,
      { id: id },
    )

    if (!complaint) {
      return null
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: complaint.customerNumber,
    })

    return complaint || null
  },
}
